
import { format } from "date-fns";

// Date formatting utility
export const formatDate = (dateString: string | null) => {
  if (!dateString) return "Not specified";
  try {
    return format(new Date(dateString), "PPP 'at' p");
  } catch (e) {
    return dateString;
  }
};
